<script setup lang="ts">
import { PropType } from 'vue'
import { TravelInfoSettings, TravelInfoTerminal } from './../../types'
import ServiceTitleArea from './ServiceTitleArea.vue'
import TravelInfoPod from './TravelInfoPod.vue'
import TravelInfoMessages from './TravelInfoMessages.vue'

defineProps({
  settings: {
    type: Object as PropType<TravelInfoSettings>,
    required: true,
  },
  terminalData: {
    type: Object as PropType<TravelInfoTerminal>,
    required: true,
  },
})
</script>

<template>
  <div class="bg p-b-x20">
    <div class="cws">
      <div class="status-card-set">
        <ServiceTitleArea :title-info="terminalData.titleInfo" />
        <div class="status-card-set__grid">
          <TravelInfoPod :travel-info="terminalData.terminalInfo.checkin" />
          <TravelInfoPod
            :travel-info="terminalData.terminalInfo.borderControls"
          />
          <TravelInfoPod :travel-info="terminalData.terminalInfo.departures" />
        </div>
      </div>
    </div>
  </div>
  <TravelInfoMessages :travel-info-messages="terminalData.travelInfo" />
</template>

<style lang="scss" scoped></style>
